import { IAdGroup } from '@unfoldrtech/portal-mic'
import { createContext } from 'react'
import { TAdGroupContext } from '../types'

export const defaultAdGroupContext: TAdGroupContext = <IAdGroup>{}

export const AdGroupContext = createContext<TAdGroupContext>(
  defaultAdGroupContext
)
